<template>
  <div id="business">
    <v-container :pa-0="$vuetify.breakpoint.smAndDown">
      <v-layout align-center justify-space-between column>
        <v-flex mb-5 text-xs-center>
          <h1
            class="
              font-weight-black
              blue-grey--text
              text--darken-4
              display-2
              text-center
            "
          >
            Business Development
          </h1>
          <br />
          <hr />
        </v-flex>
        <v-flex id="rotatingItemText" mt-5 mb-5>
          <v-card flat>
            <v-tabs
              v-model="tab"
              hide-slider
              color="grey"
              grow
              icons-and-text
              active-class="indigo--text text--darken-2 grey lighten-5 subheading font-weight-bold"
            >
              <v-tab href="#tab-0" class="text-capitalize">
                Trading Firms
                <v-icon :class="{ 'indigo--text': tab == 'tab-0' }"
                  >business</v-icon
                >
              </v-tab>

              <v-tab href="#tab-1" class="text-capitalize">
                Exchanges
                <v-icon :class="{ 'indigo--text': tab == 'tab-1' }"
                  >account_balance</v-icon
                >
              </v-tab>

              <v-tab href="#tab-2" class="text-capitalize">
                Fintech Vendors
                <v-icon :class="{ 'indigo--text': tab == 'tab-2' }"
                  >compare_arrows</v-icon
                >
              </v-tab>
              <v-tab-item
                v-for="(item, index) in rotatingItems"
                :value="'tab-' + index"
                :key="index"
              >
                <v-card flat class="grey lighten-2">
                  <div
                    class="rotatingItemBackground"
                    :class="{
                      rotatingItemBackgroundMobile:
                        $vuetify.breakpoint.smAndDown,
                    }"
                  >
                    <v-card-title>
                      <p class="blue-grey--text text--darken-4 subheading">
                        {{ item.intro }}
                      </p>
                    </v-card-title>
                    <v-card-text>
                      <ul
                        class="
                          rotatingBullets
                          blue-grey--text
                          text--darken-4
                          subheading
                        "
                      >
                        <li v-for="(each, index) in item.items" :key="index">
                          <v-icon>arrow_right</v-icon>{{ each }}
                        </li>
                      </ul>
                    </v-card-text>
                    <br />
                    <hr />
                    <br />
                    <p
                      class="
                        outroTabText
                        blue-grey--text
                        text--darken-4
                        subheading
                      "
                    >
                      {{ item.outro }}
                    </p>
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-flex>

        <v-flex mt-5>
          <p
            class="
              font-weight-medium
              blue-grey--text
              text--darken-4
              headline
              text-center
              subheaders
            "
          >
            RETHYMOS Business Development and Strategy Assistance in Depth
          </p>
          <br />
          <hr />
        </v-flex>
        <v-flex mb-5 mt-5>
          <p id="mainBusinessText" class="font-weight-light title">
            Financial markets and the technologies deployed to access and
            operate them have evolved dramatically since the first electronic
            trade was processed by Stockholm Exchange in 1990.
            <br />
            <br />
            Innovation in the vertical continues at a rapid pace, with new
            products and technologies developing globally. Innovators face
            enormous challenges in ensuring their ideas are presented to
            prospective end users and intermediaries. Access to key market
            participants can be daunting at best, even impossible at times. End
            users face a different set of challenges – keeping abreast of the
            latest technologies, innovations and services which can help ensure
            their continued success and market edge. These challenges are
            magnified by the global nature of both capital markets, location of
            innovators and their prospective clients.
            <br />
            <br />
            Enter RETHYMOS. A small group of professionals focusing on financial
            and capital markets as well as technology, with backgrounds that
            include trading, advisory and strategy, have combined to bridge the
            gap between buyers and sellers. With a strong understanding of
            market trends, market structure, new technologies and related
            performance metrics, as well as access to hundreds of the world’s
            leading market participants, RETHYMOS is well positioned to assist
            both buyers and sellers in connecting.
            <br />
            <br />
            The RETHYMOS advisory model is simple. We seek out best of breed
            solutions and innovations and work collaboratively with developers
            and groundbreaking companies to introduce their efforts to key
            market participants globally. We research, assess and evaluate the
            merits of a product or offering, and develop strategies to assist
            the originators in bringing those solutions to the attention of key
            decision makers in end user organizations. Our work is always
            customized – we have yet to run across an assignment that allows us
            to use a cookie cutter approach or pull a template off the
            proverbial shelf.

            <br /><br />
            On the contrary, we develop a deep understanding of an innovator’s
            value proposition and objectives, and work closely and
            collaboratively with the company to ensure the value propositions
            are presented and heard by decision makers in the right target
            audience. With a presence in the Americas, Europe and Asia Pacific,
            and key vendor and client end user relationships across all market
            centres globally, RETHYMOS is not only strategically positioned to
            add value, but our geographical coverage further enables connecting
            market participants throughout the world.
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: "",
      rotatingItems: [
        {
          intro:
            "As trading firms look to enter new markets, they are often faced with a multitude of issues to resolve before trading can begin. These issues typically involve several of the following questions:",
          items: [
            "What is the regulatory climate like and how does it impact our prospective activities?",
            "What corporate structure should we employ to optimise results?",
            "Which brokers are most capable and best equipped to handle our trading?",
            "What order types are possible ?",
            "How many orders can I send (or cancel) and with what frequency?",
            "What are exchange fees for different order types and how do those fees differ based on volume, status, etc.?",
            "Are rebates offered ? How are those rebates calculated?",
            "How can we procure, deploy and manage infrastructure most efficiently in the local market?",
          ],
          outro:
            " RETHYMOS helps answer these questions, with a breadth of knowledge of different trading venues globally.",
        },
        {
          intro:
            'Exchanges are always looking to deploy global "best practices" in an ongoing effort to maintain venue fairness to all investors. The nature of best practices is dynamic, and constantly evolving. RETHYMOS assists exchanges in providing guidance related to:',
          items: [
            "Regulatory Issues",
            "Exchange technology",
            "Market surveillance",
            "Peer group comparison and relevance",
          ],
          outro:
            " In essence, we can help point exchanges in the right direction, provide assurance or confirmation about a particular set of best practices, and introduce you to key market participants who can help.",
        },
        {
          intro:
            "Fintech vendors, particularly new entrants, face the daunting task of trying to get their story told to the key market participants globally. The challenges involve end user target identification, access to those end users, ensuring the message is communicated professionally, accurately and with credibility. We can assist vendors through:",
          items: [
            "Market Entry Strategy",
            "Competitive environment and product positioning",
            "Target Identification",
            "Introductions to key end user prospects",
            "Channel Development",
            "Liaising with management and internal sales personnel",
            "Use of trade shows and social media to complement sales efforts",
          ],
          outro:
            "We can assist vendors in rising above the clutter to get your message heard by the market participants that matter most to your business.",
        },
      ],
    };
  },
};
</script>

<style scoped>
#business {
  padding-top: 7%;
  line-height: 2;
}

#mainBusinessText {
  line-height: 1.6 !important;
  padding: 0px 6%;
}

.rotatingBullets {
  list-style-type: none;
  text-align: start;
  padding-left: 9%;
  padding-right: 9%;
}

.rotatingItemBackground {
  width: 90%;
  text-align: center;
  margin: auto;
  padding-top: 2%;
}

.rotatingItemBackgroundMobile {
  padding: 0%;
  width: 100%;
}

.introTabText {
  font-size: 18px;
  font-weight: 500;
}

.outroTabText {
  padding-right: 4px;
  padding-left: 4px;
  padding-bottom: 40px;
}
</style>